import React, { useState } from 'react';
import { Outlet } from 'react-router';
import { Divider } from '@abyss/web/ui/Divider';
import { Loader } from '@src/components/global/Loader';
import { AlertComponent } from '@src/components/global/AlertComponent/AlertComponent';
import { ModalComponent } from '@src/components/global/ModalComponent/ModalComponent';
import { Footer } from './Footer';
import { LeftMenu } from './LeftMenu';
import { Header } from './Header';
import { Breadcrumb } from './Breadcrumb';
import { PageTitle } from './PageTitle';
import { MainContainer, FooterContainer } from './styles';
import { GlobalStyles } from '@src/components/layouts/styles';
import { isLeftMenuEnabled } from '@src/config/CrdpConfig';
import { ToastProvider } from '@abyss/web/ui/Toast';
import styles from './Layout.module.scss';

export const Layout = () => {
  GlobalStyles();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const leftMenuEnabled = isLeftMenuEnabled();

  const Action = {
    OnMobileMenuClick: () => {
      // Only handle menu toggle if left menu is enabled
      if (!leftMenuEnabled) return;

      setIsMenuOpen(!isMenuOpen);

      const menu = document.querySelector(
        '.menu-large-screen, .menu-large-screen-open'
      );
      if (menu) {
        if (isMenuOpen) {
          menu.classList.add('menu-large-screen');
          menu.classList.remove('menu-large-screen-open');
        } else {
          menu.classList.add('menu-large-screen-open');
          menu.classList.remove('menu-large-screen');
        }
      }

      const mainBlock = document.querySelector(
        '.main-content-large-screen, .main-content-large-screen-open'
      );
      if (mainBlock) {
        if (isMenuOpen) {
          mainBlock.classList.add('main-content-large-screen');
          mainBlock.classList.remove('main-content-large-screen-open');
        } else {
          mainBlock.classList.add('main-content-large-screen-open');
          mainBlock.classList.remove('main-content-large-screen');
        }
      }
    },
  };

  // Dynamic class names based on left menu configuration
  const getMainContentClass = () => {
    if (!leftMenuEnabled) {
      return 'main-content-full-width';
    }
    return 'main-content-large-screen';
  };

  const getMainBlockClass = () => {
    if (!leftMenuEnabled) {
      return styles.mainBlockFullWidth;
    }
    return styles.mainBlock;
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header
        onMobileMenuClick={
          leftMenuEnabled ? Action.OnMobileMenuClick : undefined
        }
      />
      <div
        className="main-container"
        style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
      >
        <ToastProvider />
        <Loader>
          <MainContainer
            css={{
              ...(leftMenuEnabled ? {} : { marginLeft: '0' }),
              flex: 1,
            }}
          >
            {/* Conditionally render left menu */}
            {leftMenuEnabled && (
              <div className="menu-large-screen">
                <div className={styles.sidebarParentContainer}>
                  <div className={styles.sidebarContainer}>
                    <LeftMenu />
                  </div>
                </div>
              </div>
            )}
            <div className={getMainContentClass()}>
              <div className={getMainBlockClass()}>
                <div style={{ padding: '2px 1rem 0' }}>
                  <Breadcrumb />
                </div>
                <Divider height={1} css={{ margin: '0' }} />
                <div style={{ padding: '4px 1rem 4px' }}>
                  <PageTitle />
                </div>
                <div style={{ padding: '0 1rem 1rem' }}>
                  <AlertComponent />
                  <Outlet />
                </div>
              </div>
            </div>
          </MainContainer>
        </Loader>
        <FooterContainer>
          <Footer />
        </FooterContainer>
        <ModalComponent />
      </div>
    </div>
  );
};
